/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Board_AriaInputs */



/**
* | output |
* | --- |
* | "Kanban Board" |
*
* @param {Explorer_Kanban_Board_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_board_aria = /** @type {((inputs?: Explorer_Kanban_Board_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Board_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tableau kanban")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kanban-Board")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bacheca Kanban")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Канбан-доска")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tablero Kanban")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("看板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カンバンボード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कानबन बोर्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro Kanban")
	return /** @type {LocalizedString} */ ("Kanban Board")
});